(function () {
  function pad3(n) { return String(n).padStart(3, "0"); }

  function initOne(root) {
    if (!root || root.__tbInited) return;
    root.__tbInited = true;

    var total = parseInt(root.getAttribute("data-total"), 10) || 1;
    var base = root.getAttribute("data-base") || "";
    var ext  = root.getAttribute("data-ext") || ".webp";

    var stage = root.querySelector("[data-tb-stage]");
    if (!stage) return;

    // Espera a lib carregar (sem depender de inline onload)
    var tries = 0;
    (function waitLib() {
      tries++;
      if (window.St && window.St.PageFlip) return start();
      if (tries > 200) { console.error("TB Flipbook: PageFlip lib not found."); return; }
      setTimeout(waitLib, 50);
    })();

    function url(n) { return base + pad3(n) + ext; }

    function start() {
      // monta páginas
      stage.innerHTML = Array.from({ length: total }, function (_, i) {
        var n = i + 1;
        return '<div class="tb-page" data-page="' + n + '"><img loading="lazy" alt="Page ' + n + '"></div>';
      }).join("");

      var pf = new St.PageFlip(stage, {
        size: "stretch",
        minWidth: 320,
        maxWidth: 1400,
        minHeight: 420,
        maxHeight: 1800,
        showCover: true,
        mobileScrollSupport: true,
        maxShadowOpacity: 0.2
      });

      pf.loadFromHTML(stage.querySelectorAll(".tb-page"));

      function load(n) {
        if (n < 1 || n > total) return;
        var img = stage.querySelector('.tb-page[data-page="' + n + '"] img');
        if (img && !img.dataset.src) {
          img.dataset.src = url(n);
          img.src = img.dataset.src;
        }
      }

      function preload(n) { [n, n-1, n+1, n-2, n+2].forEach(load); }

      function current() {
        var idx = pf.getCurrentPageIndex ? pf.getCurrentPageIndex() : 0;
        var p = idx + 1;
        if (p < 1) p = 1;
        if (p > total) p = total;
        return p;
      }

      var btnPrev = root.querySelector("[data-tb-prev]");
      var btnNext = root.querySelector("[data-tb-next]");
      var btnGo   = root.querySelector("[data-tb-go]");
      var btnFull = root.querySelector("[data-tb-full]");
      var input   = root.querySelector("[data-tb-input]");
      var countEl = root.querySelector("[data-tb-count]");

      function updateUI() {
        var p = current();
        if (countEl) countEl.textContent = p + " / " + total;
        if (input) input.value = p;
      }

      preload(1);
      updateUI();

      pf.on("flip", function () {
        var p = current();
        preload(p);
        updateUI();
      });

      if (btnPrev) btnPrev.addEventListener("click", function () { pf.flipPrev(); });
      if (btnNext) btnNext.addEventListener("click", function () { pf.flipNext(); });

      if (btnGo) btnGo.addEventListener("click", function () {
        var v = parseInt(input && input.value, 10) || 1;
        if (v < 1) v = 1;
        if (v > total) v = total;
        pf.flip(v - 1);
        preload(v);
        updateUI();
      });

      if (btnFull) btnFull.addEventListener("click", function () {
        if (!document.fullscreenElement) root.requestFullscreen && root.requestFullscreen();
        else document.exitFullscreen && document.exitFullscreen();
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-tb-flipbook]").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})(); 